import { useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingApp from '../../components/LoadingApp';
import ModalFeedBack from '../../components/ModalFeedBack';
import { ComunicadosBenef } from '../../interfaces/entities/ComunicadosBenef';
import { getAgendamentosTeleatendimento } from '../../services/AgendamentoService';
import './styles.css';
import BoasVindasModal from './BoasVindasModal';
import { getModalBoasVindasJaMostrado, setModalBoasVindasJaMostrado } from '../../Store/storages/HomeScreenInfoStorage';
import HomeNotificationCard from './HomeNotificationCard';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import HomeNotificationCardMobile from './HomeNotificationCardMobile';
import { getComunicadosBenef } from '../../services/ComunicadoService';
import { TypeNotificationEnum } from '../../interfaces/enum/TypeNotificationEnum';
import {  getMostrarNovamenteBemVindo } from '../../services/Home/HomeService';
import { OpenPageType } from '../../interfaces/enum/SelectedTypeEnum';
import { faEnvelope } from '@fortawesome/pro-duotone-svg-icons';
import { RetornaAceiteTermoResponse } from '../../interfaces/entities/RetornaAceiteTermoResponse';
import ShortcutsPanel from './ShortcutsPanel';
import { scrollToImmediate } from '../../utils/ScrollUtil';
import { MenuItem } from '../../interfaces/Home/MenuItem';
import { useHomeContext } from '../../Store/contexts/HomeContext';

const Home: React.FC = () => {

  const isDesktop = useMediaQuery('(min-width: 575px)');

  const [lastUnreadNotification, setLastUnreadNotification] = useState<ComunicadosBenef | null>(null);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [textButtonModal, setTextButtonModal] = useState<string>('FECHAR');
  const [titleModal, setTitleModal] = useState<string>('Erro');
  const [subTitleModal, setSubTitleModal] = useState<string>('Erro');
  const [iconModal, setIconModal] = useState<string>('error');
  const [showModalFeedback, setShowModalFeedback] = useState<boolean>(false);
  const [showBoasVindasModal, setShowBoasVindasModal] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [acceptTerms, setAcceptTerms] = useState<RetornaAceiteTermoResponse | null>(null);
  
  const { atalhos, loading } = useHomeContext();

  const navigate = useNavigate();

  const handleModalFeedBack = () => {
    setShowModalFeedback(showModalFeedback => !showModalFeedback);
  }

  const removeDuplicateNotifications = (notifications: ComunicadosBenef[]) => {
    const uniqueIds = new Set();
    return notifications.filter((notification) => {
      if (!uniqueIds.has(notification.idComunic)) {
        uniqueIds.add(notification.idComunic);
        return true;
      }
      return false;
    });
  };

  const sortNotificationsByDate = (notifications: ComunicadosBenef[]) => {
    return notifications.sort((a, b) => {
      return new Date(b.dtIncl).getTime() - new Date(a.dtIncl).getTime();
    });
  };

  useEffect(() => {
    const getAllNotifications = async () => {
      setShowLoading(true);
      try {
  
        const todos = await getComunicadosBenef(TypeNotificationEnum.Todos);

        if (todos) {
          let result = removeDuplicateNotifications(todos);
          result = sortNotificationsByDate(result);
          const mostRecentNotification = result[0];

          if (mostRecentNotification?.indLido === 'S') {
            setLastUnreadNotification(null);
          } else {
            const firstUnreadNotification = result.find(
              (notification) => notification.indLido === 'N'
            );

            if (firstUnreadNotification) {
              setLastUnreadNotification(firstUnreadNotification);
            }
          }
        }
      } finally {
        setShowLoading(false);
      }
    };
  
    getAllNotifications();
  }, []);

  const openModalFeedBack = (textButton: string, title: string, subTitle: string, iconModal?: string) => {
    setTextButtonModal(textButton);
    setTitleModal(title);
    setSubTitleModal(subTitle);
    setIconModal(iconModal || 'error');
    handleModalFeedBack();
  }

  const handleClickIngressarNoAtendimento = async () => {
    setShowLoading(true);
    const response = await getAgendamentosTeleatendimento();
    if (response?.status === 200) {
      const availableMeetings = response.data;
      const meeting = availableMeetings.at(0);
      const telemedicinaReady = meeting?.statusTelemedicina === 'disponivel' && meeting.statusTelemedicinaAPI === 'Iniciada';
      if (meeting && telemedicinaReady) {
        const isPaVirtual = meeting.tipoAtend === 'PA VIRTUAL';
        navigate(`/saudeOnline/ingressarNoAtendimento/${isPaVirtual ? `${meeting.id}/paVirtual` : `${meeting.idReuniao}`}`);
      } else {
        const emptySchedulesMessage = 'Você não possui nenhum agendamento confirmado por telessaúde. Caso já tenha realizado um agendamento, acesse "Consultar meus agendamentos" para conferir o status.';
        openModalFeedBack('FECHAR', 'Nenhum atendimento', emptySchedulesMessage, 'warning');
      }
    } else {
      openModalFeedBack('FECHAR', 'Erro', 'Ocorreu um erro ao fazer a consulta de teleatendimentos. Tente novamente em instantes.');
    }
    setShowLoading(false);
  }

  const handleFeatureCardClick = (atalho: MenuItem) => {
    if (atalho.external) {
      window.open(atalho.path, "_blank");
    } else if (atalho.component === 'ingressarAtendimento') {
      handleClickIngressarNoAtendimento();
    } else {
      navigate(atalho.path);
      scrollToImmediate('nav-header');
    }
  }

  const handleConfirmarConsulta = () => {
    if (lastUnreadNotification) {
      const { idAgenda, tipo } = lastUnreadNotification.openComunic.abrirConfirmAgendamentoFuturo;
      navigate(`/notificacoes/saude_online/${idAgenda}/${tipo}/${lastUnreadNotification.idComunic}`)
    }
  }

  const handleMedicinaPreventiva = () => {
    if (lastUnreadNotification) {
      const { idEventoUsr } = lastUnreadNotification.openComunic.abrirGestaoConviteEventoPage;
      navigate(`/notificacoes/saude_online/medicina_preventiva/${lastUnreadNotification.idComunic}/${idEventoUsr}?lido=${lastUnreadNotification.indLido}`)
    }
  }



  const viewNotification = () => {
    if (!lastUnreadNotification) return;

    const { tipoComunic, openComunic, idComunic } = lastUnreadNotification;

    if (tipoComunic.indAbrirPesquisaSatisfacao === "S") {
      navigate(
        `/notificacoes/pesquisaDeSatifacao/${idComunic}/${openComunic.abrirPesqSatisfacao.idQuestOperador}`
      );
      return;
    }

    const redirectionPage = openComunic?.abrirPagina?.paginaRedirecionamento;

    if (redirectionPage === OpenPageType.CronicosSelecaoIndexPage) {
      navigate(
        `/saudeBemEstar/gestaoDeCronicos/captacao/inicio/${idComunic}`
      );
      return;
    }

    if (redirectionPage === OpenPageType.CronicosAdesaoTermoPage) {
      navigate(
        `/saudeBemEstar/gestaoDeCronicos/primeiroAgendamento/${idComunic}`
      );
      return;
    }

    if (redirectionPage === OpenPageType.CronicosGestaoAltaPage) {
      navigate(
        `/saudeBemEstar/gestaoDeCronicos/encerramento/${idComunic}`
      );
      return;
    }

    if (openComunic.tipoSelecionado === 'abrirConfirmAgendamentoFuturo') {
      handleConfirmarConsulta()
      return
    }


    if (openComunic.tipoSelecionado === 'AbrirGestaoConviteEventoPage') {
      handleMedicinaPreventiva()
      return
    }

    switch (tipoComunic.codigo) {
      case TypeNotificationEnum.Comunicados:
        navigate(`/notificacoes/mensagem/${idComunic}`);
        break;
      case TypeNotificationEnum.Notificacoes:
        navigate(
          `/notificacoes/${TypeNotificationEnum.Notificacoes}/${idComunic}`
        );
        break;
      case TypeNotificationEnum.PesquisaSatisfacao:
        navigate(
          `/notificacoes/pesquisaDeSatifacao/${idComunic}/${openComunic.abrirPesqSatisfacao.idQuestOperador}`
        );
        break;
      case TypeNotificationEnum.SaudeOnline:
        openComunic.abrirDetalhes !== null &&
          navigate(
            `/notificacoes/${TypeNotificationEnum.SaudeOnline}/${idComunic}`
          );
        break;
    }
  };

  useEffect(() => {
    getMostrarNovamenteBemVindo().then((response) => {
      setAcceptTerms(response)
      if (response.indAceite === 'S') {
        setShowBoasVindasModal(false)
        return
      }

      setShowBoasVindasModal(!getModalBoasVindasJaMostrado())
    })

  }, [])

  return (
    <div className='home-content'>
      {lastUnreadNotification !== null && (isDesktop ?
        <HomeNotificationCard onClick={viewNotification} icon={faEnvelope as IconDefinition} text={lastUnreadNotification.titulo} idComunic={lastUnreadNotification.idComunic} /> :
        <HomeNotificationCardMobile onClick={viewNotification} icon={faEnvelope as IconDefinition} text={lastUnreadNotification.titulo} idComunic={lastUnreadNotification.idComunic} />)}

      {atalhos.length > 0 &&
        <ShortcutsPanel onShortcutClick={handleFeatureCardClick} />}
      <LoadingApp showLoading={loading || showLoading} />
      <ModalFeedBack
        icon={iconModal as 'error' | 'success' | 'warning'}
        textButton={textButtonModal}
        title={titleModal}
        subTitle={subTitleModal}
        showModal={showModalFeedback}
        handleShowModal={handleModalFeedBack}
        showButtonModal
        handleButtonModal={handleModalFeedBack}
      />
      <BoasVindasModal
        open={!showLoading && showBoasVindasModal}
        onCloseModal={() => {
          setShowBoasVindasModal(false);
          setModalBoasVindasJaMostrado();
        }}
        acceptTerms={acceptTerms}
      />
      <ModalFeedBack
        showModal={showErrorModal}
        handleShowModal={() => setShowErrorModal(false)}
        icon={'error'}
        textButton={''}
        title={'Erro ao carregar informações do usuário.'}
        subTitle={'Tente novamente mais tarde.'}
      />
    </div>
  )
}

export default Home